// extracted by mini-css-extract-plugin
module.exports = {"fixtureFilter":"style_fixtureFilter___XFBT"};